const styles = {
  wrapperForm: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    width: '15%',
  },
  formLabel: {
    color: '#647886',
    fontSize: 12,
    fontFamily: 'Roboto',
  },
  field: {
    height: 40,
    width: 200,
  },
};

export default styles;
